import { render, staticRenderFns } from "./v3dafi.vue?vue&type=template&id=2d8f4eae&scoped=true&"
import script from "./v3dafi.vue?vue&type=script&lang=js&"
export * from "./v3dafi.vue?vue&type=script&lang=js&"
import style0 from "./v3dafi.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./v3dafi.vue?vue&type=style&index=1&id=2d8f4eae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8f4eae",
  null
  
)

export default component.exports